// extracted by mini-css-extract-plugin
export default {"content":"Content_content__liHRy","btnGroup":"Content_btnGroup__cYOzv","btn":"Content_btn__3Ks+s","card":"Content_card__KFSft"};